import { useEffect, useLayoutEffect, useState } from "react"
import { PageView } from "lib/GoogleAnalytics"
import { useLocation } from "react-router-dom"

export function useTrackNavigatedToPage(page: string) {
  const location = useLocation()
  const [hasSet, setHasSet] = useState(false)

  useEffect(() => {
    setHasSet(false)
  }, [location])

  useLayoutEffect(() => {
    if (hasSet) return

    PageView(page)
    setHasSet(true)
  }, [hasSet])

  return { hasSet }
}